export default "__VITE_ASSET__ad1ab594__"